import Styled from 'styled-components';
import { BaseColumn } from '@bit/wavfichacerta.fichacerta.shared-styles.columns';

export const BlueArrow = Styled.div`
  display: inline-block;
  border-top: 20px solid transparent;
  border-bottom: 20px solid transparent;
  border-left: ${props =>  `20px solid ${props.theme.color_purple}`};
  margin-left: 5px;

  ${({filtered}) => filtered && `
    border-left-color: transparent;
  `}

  ${({type, filtered, theme}) => {
    if(type == 'toSecondField' && filtered) {
      return `
        margin-top: 3vh;
        border-left-color: ${theme.color_purple};
      `
    } else if(type == 'toSecondField') {
      return `
        margin-top: 3vh;
        border-left-color: transparent;
      `
    }
  }}
`;

export const MonthContainer = Styled.div`
  width: 90%;
  display: inline-flex;
  background-color: ${props => props.color ? props.color : props.theme.color_purple};
  height: 40px;
  vertical-align: top;

  & span {
    color: ${props => props.theme.color_white};
    font-family: "Open Sans";
    line-height: 2.5rem;
    margin-left: 10px;
    font-size: 13px;
  };

  ${({filtered, ...props}) => filtered && `
    background-color: ${props.theme.color_white};
    border: 1px solid ${props.theme.color_purple};

    span {
      color: ${props.theme.color_purple};
    }
  `}
`;

export const FilterContainer = Styled.div`
  width: 100%;
  margin-top: 0;
`;

/** Linha: caixa de datas + botão FILTRAR alinhados */
export const FilterDateBar = Styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px 14px;
  margin-top: 0;

  & .charge-filter-submit {
    flex-shrink: 0;
    align-self: center;
    border-radius: 10px;
    font-weight: 600;
    letter-spacing: 0.06em;
    min-height: 44px;
    padding: 0.55rem 1.5rem !important;
    background: linear-gradient(180deg, #1a3d66 0%, #152b4e 55%, #122845 100%) !important;
    border: 1px solid rgba(0, 0, 0, 0.12) !important;
    box-shadow:
      0 1px 0 rgba(255, 255, 255, 0.12) inset,
      0 2px 6px rgba(21, 43, 78, 0.25);
    transition:
      transform 0.18s ease,
      box-shadow 0.18s ease,
      filter 0.18s ease;

    &:hover {
      filter: brightness(1.06);
      transform: translateY(-1px);
      box-shadow:
        0 1px 0 rgba(255, 255, 255, 0.15) inset,
        0 4px 14px rgba(21, 43, 78, 0.35);
    }

    &:active {
      transform: translateY(0);
      filter: brightness(0.98);
    }
  }
`;

export const DateContainer = Styled.div`
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  width: auto;
  max-width: min(100%, 520px);
  flex: 0 1 auto;
  margin-top: 0;
  min-height: 50px;
  height: auto;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 11px 14px 12px;
  box-sizing: border-box;
  vertical-align: top;
  background: #fff;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 1),
    0 1px 3px rgba(15, 23, 42, 0.05);
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    background 0.2s ease;

  &:focus-within {
    border-color: #7dd3fc;
    box-shadow:
      inset 0 1px 0 rgba(255, 255, 255, 1),
      0 0 0 3px rgba(125, 211, 252, 0.35),
      0 2px 8px rgba(14, 116, 144, 0.1);
  }

  & label {
    display: none;
  }
  & > div > div > div {
    margin: 0;
  }

  .field-fc {
    padding: 0;
  }

  & .filter-date-input-wrap {
    flex: 0 0 auto;
    width: 128px;
    max-width: 100%;
  }

  & .filter-date-input-wrap--year {
    width: 88px;
  }

  & .filter-date-input-wrap--month {
    width: 152px;
  }

  & .filter-date-input-wrap .field-fc,
  & .filter-date-input-wrap .field-fc > div {
    width: 100% !important;
    max-width: 100% !important;
  }

  span {
    color: #475569;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.02em;
  }

  select {
    width: 100%;
    height: 34px;
    background: #fff !important;
    color: #152b4e !important;
    border: 1px solid #cbd5e1 !important;
    border-radius: 8px !important;
    padding: 0 10px;
    font-size: 13px;
    font-weight: 500;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);
    transition: border-color 0.15s ease, box-shadow 0.15s ease;

    &:hover {
      border-color: #94a3b8 !important;
    }

    &:focus {
      outline: none;
      border-color: #38bdf8 !important;
      box-shadow: 0 0 0 3px rgba(56, 189, 248, 0.25);
    }
  }

  input {
    color: #152b4e !important;
    background: #fff !important;
    border: 1px solid #cbd5e1 !important;
    border-radius: 8px !important;
    padding: 7px 10px !important;
    font-size: 13px !important;
    font-weight: 500 !important;
    height: 34px !important;
    box-sizing: border-box !important;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;
    transition: border-color 0.15s ease, box-shadow 0.15s ease !important;

    &:hover {
      border-color: #94a3b8 !important;
    }

    &:focus {
      outline: none !important;
      border-color: #38bdf8 !important;
      box-shadow: 0 0 0 3px rgba(56, 189, 248, 0.25) !important;
    }
  }

  ${({ filtered }) => filtered && `
    background: linear-gradient(180deg, #f0f9ff 0%, #e0f2fe 100%);
    border-color: #7dd3fc;
    box-shadow:
      inset 0 1px 0 rgba(255, 255, 255, 0.65),
      0 2px 8px rgba(14, 116, 144, 0.1);
  `}

  @media (max-width: 800px) {
    width: 100%;
    max-width: 100%;
    padding: 10px 10px 11px;

    .filter-date-fields-row {
      display: grid !important;
      grid-template-columns: auto minmax(0, 1fr) auto minmax(0, 1fr);
      align-items: center !important;
      gap: 6px 8px !important;
      width: 100%;
      flex-wrap: nowrap !important;
    }

    .filter-date-fields-row .filter-date-label {
      white-space: nowrap;
      font-size: 11px;
    }

    .filter-date-fields-row .filter-date-input-wrap {
      width: 100% !important;
      min-width: 0 !important;
      flex: 1 1 auto !important;
    }
  }
`;

export const TableWrapper = Styled(BaseColumn)`
  & .odd {
    background-color: rgba(0, 0, 0, 0.05);

    tr, table {
      background-color: transparent !important;
      
      th, td {
        font-size: 11px !important;
        padding: 0 8px .3rem 8px;
      }

      &:hover {
        background-color: transparent !important;
      }
    }
  }

  & .even {
    background-color: transparent;

    tr, table {
      background-color: transparent !important;
      
      th, td {
        font-size: 11px !important;
        padding: 0 8px .3rem 8px;
      }

      &:hover {
        background-color: transparent !important;
      }
    }
  }
`;

export const BasicContainer = Styled.div`
  width: 90%;
`;

export const ResumeContainer = Styled.div`
  width: 100%;
  border: 1px solid #dee2e6;

  & > div {
    margin: 0 .5rem;
    padding: 0 0 0 .5rem;
    width: 92%;
  }
  
  & > div:last-child {
    margin: 0 .5rem .5rem .5rem;
  }

  & > div:first-child {
    margin: .5rem .5rem 0 .5rem;
  }

  & > div:only-child {
    margin: .5rem .5rem .5rem .5rem;
  }

  & > div:nth-child(odd) {
    background-color: #152b4e26;
  }
`;

export const ResumeSpan = Styled.span`
  font-size: .8rem;
  color: ${props => props.theme.color_gray};
  font-weight: 500;
`;

export const Line = Styled.div`
  height: 47px;
  border: 0.5px solid #dee2e6;
  width: 0.1px;
  position: relative;
  left: 50%;
`;

export const ValueContainer = Styled.div`
  min-height: 47px;
  border: 0.5px solid #dee2e6;
  padding: .5rem 0;
  margin-bottom: 5px;
`;

export const ValueTitle = Styled.p`
  font-size: 1.2rem;
  margin: 0 0 0 1rem;
  font-weight: 500;
  color: ${props => props.theme.color_purple};
`;

export const TotalValue = Styled.p`
  font-size: 1.4rem;
  text-align: right;
  margin: 0 1rem 0 0;
  font-weight: 500;
  color: ${props => props.theme.color_gray};
`;

export const ResumeTitle = Styled.p`
  font-size: 17px;
  color: ${props => props.theme.color_purple};
  margin-bottom: 3px;
`;

export const Caption = Styled.p`
  font-size: 10px;
  text-align: right;
  margin: .25rem 0;
  color: ${props => props.theme.color_gray};
`;